import { toJS } from "mobx";
import { store } from "@store";
import { useMemo } from "react";
import { Message } from "@store/SnackbarStore";
import {
  useMyProfile_GetAllowedCostCentersQuery,
  useFetchStaticData_ProjectsQuery,
  ProjectVisibilityContext
} from "@graphql";

export function useGlobalStore() {
  return store();
}

export function useCostCenters() {
  const { data, loading } = useMyProfile_GetAllowedCostCentersQuery({
    fetchPolicy: "network-only"
  });

  const costCenters = useMemo(() => data?.me?.allowedCostCenters ?? [], [data]);

  return { costCenters, loading };
}

export function useRegularProjects(
  skip = false,
  visibilityContext: ProjectVisibilityContext = null
) {
  const { data, loading } = useFetchStaticData_ProjectsQuery({
    variables: { visibilityContext },
    fetchPolicy: "network-only",
    skip
  });

  const projects = useMemo(() => data?.projects ?? [], [data]);
  const regularProjects = useMemo(
    () => projects.filter((x) => parseInt(x.ProjectNumber) <= 9000),
    [projects]
  );

  return { regularProjects, loading };
}

export function useUserProfile() {
  return store().user;
}

export function useTeams() {
  return toJS(store().cache.teams);
}

export function useTicketTeamOptions() {
  const teams = useTeams();

  return teams
    .filter(
      (x) =>
        x.TodoGroup !== "Staffing" &&
        x.TodoGroup !== "FinanceDepartment" &&
        x.TodoGroup !== "TravelAndAccommodation"
    )
    .map((x) => ({ label: x.Name, value: x.TodoGroup }));
}

export function useSnackbars() {
  const showSuccess = (message: Message) => store().snackbars.success(message);
  const showError = (message: Message) => store().snackbars.error(message);
  const showInfo = (message: Message) => store().snackbars.info(message);

  return { showSuccess, showError, showInfo };
}
